import { BCDataGrid, BCTreeList } from '@bimser/components';
import DataGrid2 from '../..';
import { IRowDoubleClickEventArgs } from '../../../../entities/EventArgs';

export async function onRowDblClick(
	this: DataGrid2,
	e:
		| BCDataGrid.Entities.DataGridTypes.RowDblClickEvent
		| BCTreeList.Components.TreeListTypes.RowDblClickEvent
) {
	await this.emit('event:OnRowDoubleClick', { row: e.data } as IRowDoubleClickEventArgs);
}
